import { universalTemplate } from "./../templates/Universal";
import { BaseCollection } from "./BaseCollection";
import DM from '@tencent/xy-dm';
import { getCollection } from "./getCollection";
const DMCtor = DM;
/**
 * 关系型数据源使用的请求对象  依赖DM
 */
export class RelationalCollection extends BaseCollection {
  constructor(collectionData, options) {
    super(collectionData, options);
    this.template = universalTemplate;
    this.readyTask = new Promise(r => this.ready = r);
    this.list = async ({
      body
    }) => {
      var _body$include, _body$exclude;
      const res = await this.dm.list({
        page: body.page,
        size: body.size,
        include: (_body$include = body.include) === null || _body$include === void 0 ? void 0 : _body$include.split(','),
        exclude: (_body$exclude = body.exclude) === null || _body$exclude === void 0 ? void 0 : _body$exclude.split(','),
        filter: body.filter,
        sort: body.sort
      });
      logError(res);
      return getResult(res);
    };
    this.count = async ({
      body
    }) => {
      const res = await this.dm.count({
        filter: body.filter
      });
      logError(res);
      return getResult(res);
    };
    this.create = async params => {
      const {
        body
      } = params;
      const res = await this.dm.create({
        data: body
      });
      logError(res);
      return getResult(res);
    };
    this.update = async (params, options) => {
      if (!(options !== null && options !== void 0 && options.oldData)) {
        throw new Error('[update] oldData 为空');
      }
      const {
        body,
        query
      } = params;
      const {
        id
      } = query;
      const res = await this.dm.update({
        id: id,
        data: body,
        oldData: options === null || options === void 0 ? void 0 : options.oldData
      });
      logError(res);
      return getResult(res);
    };
    this.get = async params => {
      const {
        body,
        query
      } = params;
      const id = (query === null || query === void 0 ? void 0 : query.id) || (body === null || body === void 0 ? void 0 : body.id);
      const res = await this.dm.get({
        id: id
      });
      logError(res);
      return getResult(res);
    };
    this.delete = async (params, options) => {
      const {
        body,
        query
      } = params;
      const id = (query === null || query === void 0 ? void 0 : query.id) || (body === null || body === void 0 ? void 0 : body.id);
      if (!(options !== null && options !== void 0 && options.oldData)) {
        throw new Error('[delete] oldData 为空');
      }
      const res = await this.dm.delete({
        id: id,
        oldData: options === null || options === void 0 ? void 0 : options.oldData
      });
      logError(res);
      return getResult(res);
    };
    if (collectionData.type !== 'combineData') {
      throw new Error(`[${collectionData.id}]不是关系型数据源`);
    }
    this.dm = new DMCtor(this.collectionData, {
      getCollection,
      option: options
    });
    this.init();
  }
  async init() {
    // 异步获取实体 写到 collection.collectionData.entity 里保证后面逻辑一致(getEntitySchema是同步的)
    // 子表多可能会慢，批量查collection可提升性能
    const entity = await this.dm.getEntitySchema();
    this.collectionData.entity = entity;
    this.ready();
  }
  async copyEntity(oldData) {
    const res = await this.dm.copy({
      oldData
    });
    if (res.code === 0) {
      return res.data;
    }
    console.error('[dm] copy fail', res);
    throw new Error(`[dm] copy fail: ${res.message}`);
  }
}
function logError(res) {
  var _res$errorData;
  if ((_res$errorData = res.errorData) !== null && _res$errorData !== void 0 && _res$errorData.length) {
    console.error('组合接口报错', res.errorData);
  }
}
function getResult(res) {
  return {
    body: {
      data: res.data,
      code: res.code,
      message: res.message,
      extra: res.extra
    }
  };
}
//# sourceMappingURL=RelationalCollection.js.map
